<ng-content></ng-content>
<div
  *ngIf="flagged"
  class="cvc-badge badge-flags"
  [ngStyle]="{ background: flagColor }"></div>
<div
  *ngIf="hasRevisions"
  class="cvc-badge badge-revisions"
  [ngStyle]="{ background: entityColor }"></div>
<div
  *ngIf="hasComments"
  class="cvc-badge badge-comments"
  [ngStyle]="{ background: entityColor }"></div>
